// extracted by mini-css-extract-plugin
module.exports = {"results":"quick-search_results__2uLi1","group":"quick-search_group__2qdbC","count":"quick-search_count__3Xzbb"};